import { Outlet, useMatches } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import { SpaceBackground } from '@/components/SpaceBackground'
import { useTheme } from '@/contexts/ThemeContext'

const PAGE_TITLES: Record<string, string> = {
  dashboard: 'Dashboard',
  leads: 'Leads',
  'lead-detail': 'Lead Detail',
  icps: 'Ideal Customer Profiles',
  'icp-detail': 'ICP Detail',
  imports: 'Imports',
  'scrape-jobs': 'Scrape Jobs',
  sequences: 'Sequences',
  'sequence-detail': 'Sequence Editor',
  'opt-outs': 'Opt-outs',
  settings: 'Settings',
  'extension-tokens': 'Extension Tokens',
  analytics: 'Analytics',
  tasks: 'Tasks',
  users: 'Users',
  'user-settings': 'My Settings',
  'admin-pin': 'Admin PIN',
  'brevo-settings': 'Brevo Integration',
  'gmail-settings': 'Gmail Integration',
  'system-emails': 'System Email Templates',
  'system-email-editor': 'Email Template Editor',
  'synced-emails': 'Synced Emails',
  'bulk-send-launch': 'Bulk Send',
  'bulk-send-history': 'Bulk Send History',
  'bulk-send-detail': 'Bulk Send Detail',
  'upload-portal-manager': 'Upload Portals',
  'crm-imports': 'CRM Imports',
  'crm-import-detail': 'Import Detail',
}

export function AppShell() {
  const matches = useMatches()
  const lastMatch = matches[matches.length - 1]
  const title = lastMatch?.id ? PAGE_TITLES[lastMatch.id] : undefined
  const { isDark } = useTheme()

  return (
    <div className={`min-h-screen ${isDark ? 'bg-black' : 'bg-white'}`}>
      {/* Animated space background when in dark mode */}
      {isDark && <SpaceBackground />}

      <div className="relative z-10">
        <Sidebar />
        <Topbar title={title} />
        <main className="pl-60 pt-14">
          <div className="p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
